<template>
  <div class="audit_container">
    <div class="tab_container" ref="tabsContaniner">
      <div class="audit_select_flex">
        <el-tabs v-model="confirmStatus">
          <el-tab-pane label="待确认" name="unConfirm">
            <div class="audit_select_box" style="width: 360px">
              <div class="audit_select_item">
                <span class="search-title">考生信息：</span>
                <el-input 
                  class="inputBox"
                  style="width: 205px;" 
                  v-model="keyword" 
                  @change="getPageList()" 
                  placeholder="输入姓名或手机号" 
                  ></el-input>
              </div>
              <div class="audit_select_item">
                <span class="search-title">批次：</span>
                <el-select v-model="appraisalId" placeholder="全部批次" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in batchList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title" style="margin-left: 30px">工种：</span>
                <el-select v-model="occupationId" placeholder="全部工种" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in workTypeList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title" style="margin-left: 60px">科目：</span>
                <el-select v-model="subject" placeholder="全部科目" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in subjectList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.subject"></el-option>
                </el-select>
              </div>
            </div>
            <div class="audit_select_box" style="width: 360px">
              <div class="audit_select_item">
                <span class="search-title">文化程度：</span>
                <el-select v-model="examRecord" placeholder="全部文化程度" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in degreeList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title">等级：</span>
                <el-select v-model="occupationLevelCode" placeholder="全部等级" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in levelList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.code"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title">支付状态：</span>
                <el-select v-model="unConfirmPayStatus" placeholder="全部支付状态" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in payStatusList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title">报名审核状态：</span>
                <el-select v-model="unConfirmAuditStatus" placeholder="全部报名审核状态" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in unConfirmList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="audit_button_box">
              <el-button type="primary" @click="onPass(multipleSelection)" >通过</el-button>
              <el-button type="primary" @click="onReject(multipleSelection)" >驳回</el-button>
              <el-button type="primary" @click="onConfirmReceipt(multipleSelection)" >确认已收款</el-button>
              <el-dropdown>
                <el-button type="primary"  style="margin-left: 10px" :loading="exportLoadingFlag" >导出</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div @click="onExportAll">导出所有考生报名信息EXCEL</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 表格 -->
            <div class="table_wrapper">
              <div class="table_content">
                <el-table border 
                  ref="multipleTable" 
                  :data="examarr" 
                  max-height="650" 
                  @row-click="handleRowClick" 
                  :row-key="getRowKeys" 
                  :row-class-name="tableRowClassName"
                  stripe
                  
                  @select="selectChange"
                  @selection-change="handleSelectionChange">   <!-- @select-all="selectAll" :row-style="rowStyle" -->
                  <el-table-column type="selection" reserve-selection width="40"></el-table-column>  
                  <el-table-column prop="serial" width="50" label="序号"></el-table-column>
                  <el-table-column prop="examName" width="70" label="姓名"></el-table-column>
                  <el-table-column prop="examRecord" width="80" label="文化程度"></el-table-column>
                  <el-table-column prop="appraisalBatchName" label="批次名称"></el-table-column>
                  <el-table-column prop="examSubiectName" width="95" label="工种"></el-table-column>
                  <el-table-column prop="examRank" label="等级"></el-table-column>
                  <el-table-column prop="subject" width="95" label="科目"></el-table-column>
                  <el-table-column prop="examPhone" width="108" label="手机号"></el-table-column>
                  <el-table-column prop="examDate" width="152" label="报名时间"></el-table-column>
                  <el-table-column width="100" label="考生来源">
                    <template slot-scope="{row}">
                      <span v-if="row.examPay==='examineePay'">自主报名</span>
                      <span v-else>{{row.tenantor}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="95" label="机构申请人">
                    <template slot-scope="{row}">
                      <span v-if="row.examPay==='examineePay'">-</span>
                      <span v-else>{{row.creator}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="examPayText" label="交费类别"></el-table-column>
                  <el-table-column prop="payTypeText" label="支付方式"></el-table-column>
                  <el-table-column prop="payStatusText" label="支付状态"></el-table-column>
                  <el-table-column label="支付凭证">
                    <template slot-scope="{row}">
                      <div class="table_content_operation">
                        <el-tooltip class="item" effect="dark" content="预览" placement="bottom">
                          <img 
                            v-if="row.payStatus === 'payConfirm' && row.examPay === 'institutionPay'" 
                            style="width: 25px; height: 25px" 
                            src="@/assets/preview_pay.png" 
                            alt="" 
                            @click="payPreview(row.payVoucher)" />
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="orderNo" width="135" label="订单编号"></el-table-column>
                  <el-table-column prop="statusText" width="105" label="报名审核状态"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="{row}">
                      <div class="table_content_operation">
                        <!-- 查看考生信息图标 -->
                        <el-tooltip class="item" effect="dark" content="查看考生信息" placement="bottom">
                          <img id="preview" class="operation_img" @click.native.stop="studentInfoReview(row)" src="@/assets/chakan.png" />
                        </el-tooltip>
                        <!-- 通过图标-->
                        <el-tooltip class="item" effect="dark" content="通过" placement="bottom">
                          <img 
                            v-if="row.status === 'auditing' ||  row.status === 'beingReviewed'" 
                            class="operation_img" 
                            id="pass"
                            @click.stop="gotoPass(row)" 
                            src="@/assets/gouhao.png"/>
                        </el-tooltip>
                        <!-- 确认已收款图标-->
                        <el-tooltip class="item" effect="dark" content="确认已收款" placement="bottom">
                          <img 
                            v-if="(row.examPay==='institutionPay' && row.status ==='payAuditing' && row.payType !== null)" 
                            class="operation_img"
                            id="confirm" 
                            @click.stop="gotoConfirm(row)" 
                            src="@/assets/receipt.png"/>
                        </el-tooltip>
                        <!-- 驳回图标 -->
                        <el-tooltip class="item" effect="dark" content="驳回" placement="bottom">
                          <img 
                            v-if="row.examPay ==='institutionPay' 
                              && row.status ==='auditing' 
                              && row.payType === null 
                              || row.examPay ==='institutionPay' 
                              && row.status ==='beingReviewed' 
                              || row.examPay ==='institutionPay' 
                              && row.status ==='payAuditing' 
                              && row.payType !== null 
                              || row.examPay ==='examineePay' 
                              && row.payType !== null" 
                            class="operation_img" id="reject" @click.stop="gotoReject(row)" src="@/assets/bohui.png"/>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="page_footer">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[12, 24, 48, 360]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="listCount"></el-pagination>
            </div>
            <el-dialog title="提示" :visible.sync="passDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
              <span style="text-align: center">确定要通过该考生的报考信息吗?</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="onPassCancel">取 消</el-button>
                <el-button type="primary" @click="onPassConfirm" ref="passConfirm">确 定</el-button>
              </span>
            </el-dialog>
            <el-dialog title="提示" :visible.sync="confirmDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
              <span style="text-align: center">确定已收到款项？点击确定后,与当前考生相同订单编号的其他考生都将确认已收款</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="onReceiptCancel">取 消</el-button>
                <el-button type="primary" @click="onReceiptConfirm">确 定</el-button>
              </span>
            </el-dialog>
            <el-dialog title="驳回原因" :visible.sync="rejectDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
              <textarea v-model="rejectReason" name="" id="" cols="30" rows="10" placeholder="输入文字" style="background-color: #f6f6f6;border: none; width: 100%"></textarea>
              <span slot="footer" class="dialog-footer">
                <el-button @click="onRejectCancel">取 消</el-button>
                <el-button type="primary" @click="onRejectConfirm">确 定</el-button>
              </span>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane label="已确认" name="confirmed">
            <div class="audit_select_box" style="width: 360px">
              <div class="audit_select_item">
                <span class="search-title">考生信息：</span>
                <el-input 
                  class="inputBox"
                  style="width: 205px" 
                  v-model="keyword" 
                  @change="getPageList()" 
                  placeholder="输入姓名或手机号" 
                  ></el-input>
              </div>
              <div class="audit_select_item">
                <span class="search-title">批次：</span>
                <el-select v-model="appraisalId" placeholder="全部批次" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in batchList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title" style="margin-left: 30px">工种：</span>
                <el-select v-model="occupationId" placeholder="全部工种" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in workTypeList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title" style="margin-left: 60px">科目：</span>
                <el-select v-model="subject" placeholder="全部科目" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in subjectList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.subject"></el-option>
                </el-select>
              </div>
            </div>
            <div class="audit_select_box" style="width: 360px">
              <div class="audit_select_item">
                <span class="search-title">文化程度：</span>
                <el-select v-model="examRecord" placeholder="全部文化程度" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in degreeList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title">等级：</span>
                <el-select v-model="occupationLevelCode" placeholder="全部等级" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in levelList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.code"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title">支付状态：</span>
                <el-select v-model="confirmedPayStatus" placeholder="全部支付状态" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in confiremedPayStatusList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="audit_select_item">
                <span class="search-title">报名审核状态：</span>
                <el-select v-model="confirmedAuditStatus" placeholder="全部报名审核状态" class="selectBox" style="width: 205px">
                  <el-option 
                  v-for="(item,index) in confirmedList" 
                  :key="index" 
                  :label="item.name" 
                  :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="audit_button_box">
              <el-dropdown>
                <el-button type="primary"  style="margin-left: 10px" :loading="exportLoadingFlag" >导出</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div @click="onExport(multipleSelection)">导出所有评价方审核名单信息EXCEL</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 表格 -->
            <div class="table_wrapper">
              <div class="table_content">
                <el-table 
                  ref="multipleTable" border 
                  :data="examarr" 
                  max-height="650" 
                  @row-click="handleRowClick" 
                  :row-key="getRowKeys"
                  :row-class-name="tableRowClassName"
                  stripe
                  
                  @select="selectChange"
                  @selection-change="handleSelectionChange">   <!-- @select-all="selectAll" :row-style="rowStyle" -->
                  <el-table-column type="selection" reserve-selection width="40"></el-table-column>  
                  <el-table-column prop="serial" width="50" label="序号"></el-table-column>
                  <el-table-column prop="examName" width="70" label="姓名"></el-table-column>
                  <el-table-column prop="examRecord" width="80" label="文化程度"></el-table-column>
                  <el-table-column prop="appraisalBatchName" label="批次名称"></el-table-column>
                  <el-table-column prop="examSubiectName" width="95" label="工种"></el-table-column>
                  <el-table-column prop="examRank" label="等级"></el-table-column>
                  <el-table-column prop="subject" width="95" label="科目"></el-table-column>
                  <el-table-column prop="examPhone" width="108" label="手机号"></el-table-column>
                  <el-table-column prop="examDate" width="152" label="报名时间"></el-table-column>
                  <el-table-column width="100" label="考生来源">
                    <template slot-scope="{row}">
                      <span v-if="row.examPay==='examineePay'">自主报名</span>
                      <span v-else>{{row.tenantor}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="95" label="机构申请人">
                    <template slot-scope="{row}">
                      <span v-if="row.examPay==='examineePay'">-</span>
                      <span v-else>{{row.creator}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="examPayText" label="交费类别"></el-table-column>
                  <el-table-column prop="payTypeText" label="支付方式"></el-table-column>
                  <el-table-column label="支付状态">
                    <template slot-scope="{row}">
                      <span v-if="!(row.payType == 'payByBankCard' && row.examPay == 'institutionPay' && row.payStatus == 'rejected')">{{row.payStatusText}}</span>
                      <!-- 鼠标移动上去, 显示驳回原因 -->
                      <el-popover v-if="row.payType == 'payByBankCard' && row.examPay == 'institutionPay' && row.payStatus == 'rejected'" popper-class="popper-box" placement="bottom" trigger="hover" :content="row.examReject" width="200">
                        <div slot="reference">{{row.payStatusText}}</div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="支付凭证">
                    <template slot-scope="{row}">
                      <div class="table_content_operation">
                        <el-tooltip class="item" effect="dark" content="预览" placement="bottom">
                          <img style="width: 25px; height: 25px" src="@/assets/preview_pay.png" alt="" v-if="row.payType == 'payByBankCard' && row.examPay == 'institutionPay'" @click="payPreview(row.payVoucher)" />
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="orderNo" width="135" label="订单编号"></el-table-column>
                  <el-table-column width="105" label="报名审核状态">
                    <template slot-scope="{row}">
                      <span v-if="row.status !== 'rejected'">{{row.statusText}}</span>
                      <!-- 鼠标移动上去, 显示驳回原因 -->
                      <el-popover v-if="row.status == 'rejected'" popper-class="popper-box" placement="bottom" trigger="hover" :content="row.examReject" width="200">
                        <div slot="reference">{{row.statusText}}</div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column prop="auditor" width="80" label="审核人"></el-table-column>
                  <el-table-column prop="auditTime" width="152" label="审核时间"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="{row}">
                      <div class="table_content_operation">
                        <!-- 查看考生信息图标 -->
                        <el-tooltip class="item" effect="dark" content="查看考生信息" placement="bottom">
                          <img id="preview" class="operation_img" @click.native.stop="studentInfoReview(row)" src="@/assets/chakan.png" />
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="page_footer">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[12, 24, 48, 360]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="listCount"></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <preview-handout 
        v-model="payPreviewFlag" 
        :previewUrl="currentPreviewUrl"
      ></preview-handout>
    </div>
    <Info v-show="showDetail" class="info_container" ref="infoContainer" :detailInfoId="infoId" :detailInfo="detailInfo"></Info>
  </div>
</template>
 
<script>
import PreviewHandout from "@/components/previewHandout/previewHandout.vue" 
import Confirmed from "./Confirmed.vue";
import Info from "@/view/organization/batchSignUp/info.vue";
import { downloadBlob } from '@/utils/util.js'
import {Button, Tabs, Tooltip, Pagination, TabPane, Row} from 'element-ui'
 
export default {
  name: "associationAudit",
  components: {
    Confirmed,
    Button,
    Tabs,
    Tooltip,
    Pagination,
    TabPane,
    Row,
    Info,
    PreviewHandout
  },
 
  data() {
    return {
      passDialogVisible: false,  // 控制 点击 "通过" 图标时 ，对话框 的 显示 与隐藏
      rejectDialogVisible: false,  // 控制 点击 "驳回" 图标时 ，对话框的 显示 与隐藏
      confirmDialogVisible: false, // 控制 点击 "确认已收款" 图标时 ，对话框 的 显示 与隐藏
      multipleSelection: [],  //选中的数据
      payPreviewFlag: false,
      showDetail: false, // 是否显示详情页
      currentPreviewUrl: "", //预览图片的url,
      batchList: [{'name': '全部批次', 'id': ''}],
      subjectList: [
        { name: '全部科目', subject: '' },
      ],
      keyword: '',
      appraisalId: '', //批次id
      occupationId: '', // 工种
      subject: '', // 科目
      examRecord: '', // 文化程度
      occupationLevelCode: '',  // 等级
      unConfirmPayStatus: '', // 待确认时绑定的支付状态
      confirmedPayStatus: '', // 已确认时绑定的支付状态
      unConfirmAuditStatus: '', // 待确认时绑定的报名审核状态
      confirmedAuditStatus: '', // 已确认时绑定的报名审核状态
      status: '',
      workTypeList: [
        {code: '', id: '', levelDetails: [],logo: '', name: '全部工种', professionCode: '', professionName: '', remark: ''}
      ], 
 
      degreeList: [
        {name: '全部文化程度', value: '' },
        {name: '博士', value: '博士'},
        {name: '硕士', value: '硕士'},
        {name: '大学', value: '大学'},
        {name: '大专', value: '大专'},
        {name: '中专', value: '中专'},
        {name: '职高', value: '职高'},
        {name: '技校', value: '技校'},
        {name: '高中', value: '高中'},
        {name: '初中', value: '初中'},
        {name: '小学', value: '小学'},
        {name: '其他', value: '其他'}
      ],
 
      statusObj:{
        payConfirm: "待确认",
        paid: "已支付",
        unConfirm: "机构确认中",
        // '未确认' tab 选项中的报名审核状态
        beingReviewed: "待审核",
        unAppointment: "通过",
        // '已确认' tab 选项中的报名审核状态
        toTest: "通过",
        rejected: "驳回",
        UnPassFirstTrial: "初审未通过",
        unPay: "待支付",
        rejectedEvaluator: "评价方驳回",
        serial: "支付审核中",
        auditing: "待审核",
        examineePay: "考生交费",
        institutionPay: "机构交费",
        onlinePay: "线上支付",
        payByBankCard: "银行卡转账",
        payAuditing: "通过",
        payRejected: "通过"
      },
      levelList: [
        {code:'',  name: '全部等级'}
      ],
 
      // "未确认" tabs 选项下的 全部支付状态
      payStatusList: [
        {name: '全部支付状态', value: '' },
        {name: '待确认', value: 'payConfirm'},
        {name: '已支付', value: 'paid'},
      ],
 
      // "已确认" tabs 选项下的 全部支付状态
      confiremedPayStatusList: [
        {name: '全部支付状态', value: '' },
        {name: '已支付', value: 'paid'},
        {name: '驳回', value: 'rejected'},
      ],
 
      // "未确认" tabs 选项下的 全部报名审核状态
      unConfirmList: [
        {name: '全部报名审核状态', value: '' },
        {name: '待审核', value: 'toAudit'},
        {name: '通过', value: 'passed'}
      ],
 
      // "已确认" tabs 选项下的 全部报名审核状态
      confirmedList: [
        {name: '全部报名审核状态', value: '' },
        {name: '通过', value: 'passed'},
        {name: '驳回', value: 'reject'},
      ],
      total: 0,
      confirmStatus: "unConfirm",
      examarr: [],
      listCount: 0,
      page: 1,
      size: 12,
      rejectReason: '', // 驳回原因
      passId: '',
      rejectId: '',
      receiptId: '',
      passRow: {},
      rejectRow: {},
      receiptRow: {},
      exportLoadingFlag: false,
      infoId: '',
      detailInfo: {},
    }
  },
  created() {
    this.getPageList()
    this.getWorkTypeList()
    this.getBatchList()
    window.vue = this
  },
  watch: {
    // 考生信息
    keyword: function(){
      this.page = 1
      this.getPageList()
    },
    // 待确认时的报名审核状态
    unConfirmAuditStatus: function(){
      this.page = 1
      this.getPageList()
    },
    // 已确认时的报名审核状态
    confirmedAuditStatus: function(){
      this.page = 1
      this.getPageList()
    },
    // 文化程度
    examRecord: function(){
      this.page = 1
      this.getPageList()
    },
    
    //批次
    appraisalId: function() {
      this.page = 1
      this.getPageList()
    },
    // 工种
    occupationId: function(){
      this.page = 1
      this.getPageList()
    },
    // 等级
    occupationLevelCode: function(){
      this.page = 1
      this.getPageList()
    },
    // 科目
    subject: function() {
      this.page = 1
      this.getPageList()
    },
    // 待确认时的支付状态
    unConfirmPayStatus: function() {
      this.page = 1
      this.getPageList()
    },
    // 已确认时的支付状态
    confirmedPayStatus: function() {
      this.page = 1
      this.getPageList()
    },
    // 切换 '未确认' 与 '已确认' tab 选项
    confirmStatus: function () {
      this.page = 1
      this.getPageList();
    }
  },
  computed: {
    pageCount: function() {
      return this.listCount % this.size === 0 ? parseInt(this.listCount / this.size) : parseInt(this.listCount / this.size) + 1
    },
    //判断是手机端还是pc端
    isMobile: function(){
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.$store.commit('equipment/isMobile', true)
        return true; // 移动端
      }else{
        this.$store.commit('equipment/isMobile', false)
        return false; // PC端
      }
    },
  },
  methods: {
    // 查询现有批次信息
    getBatchList: function() {
      this.$http.get('/examination/batch/list').then(res => {
        if(res.data.success){
          this.batchList = this.batchList.concat(res.data.data)
          this.appraisalId = this.batchList.find(element => element.occupationLevelCode === 'sk-003' ).id
          this.getPageList()
        }
      })
    },

    // 获取工种数据
    getWorkTypeList(){
      this.$http.get(`/association/getOccupations`).then((res) => {
        if (res.data.success && res.status == 200) {
          this.workTypeList = [...this.workTypeList, ...res.data.data]
          this.levelList = [...this.levelList, ...res.data.data.map(item => item.levelDetails)[0]]
          this.subjectList = [...this.subjectList, ...res.data.data.map(item => item.levelDetails)[0].map(item => item.subjectDetails)[0]]
        }
      })
    },
 
    // 获取列表数据
    getPageList(){ 
      let params = {
        auditStatus: this.confirmStatus == 'unConfirm' ? this.unConfirmAuditStatus : this.confirmedAuditStatus, // 报名审核状态
        examRecord: this.examRecord, // 文化程度
        keyword: this.keyword,
        occupationId: this.occupationId, // 工种
        occupationLevelCode: this.occupationLevelCode, // 等级
        opStatus: this.confirmStatus, // 控制 tabs 选项的 状态是 "未确认" 还是 "已确认"
        page: this.page, // 当前是 第 几页
        payStatus: this.confirmStatus == 'unConfirm' ? this.unConfirmPayStatus : this.confirmedPayStatus, // 支付状态
        size: this.size, // 每一页展示多少条数据
        subject: this.subject, // 科目
        appraisalId: this.appraisalId
      }
      
      this.$http.post(`association/findAll`, params).then((res) => {
        if (res.data.success && res.status == 200) {
          this.listCount = res.data.data.count 
          let list = res.data.data.list || []
          if(res.data.data.list){
            list.forEach((element, index) => {
              element.payStatusText = this.statusObj[element.payStatus];
              element.payTypeText = this.statusObj[element.payType];
              element.statusText = this.statusObj[element.status]; // 报名审核状态
              element.examPayText = this.statusObj[element.examPay];
              element.payConfirm = this.statusObj[element.payStatus];
              element.serial = (this.page - 1) * params.size + (index + 1)
              // 格式化时间: 去掉报名时间中的 T
              if(element.examDate){
                element.examDate = element.examDate.split('T')[0] + ' ' + element.examDate.split('T')[1].split('.')[0]
              }else{
                element.examDate = ''
              }
            })
          }
          this.examarr = list
        }
      })
    },
 
    // 每一页显示多少条数据
    handleSizeChange(val) {
      this.page = 1
      this.size = val
      this.getPageList()
    },
 
    // 切换当前显示 第 几 页
    handleCurrentChange(newPage) {
      this.page = newPage
      this.getPageList()
    },
 
    // 点击 表格中的 "某一行" 触发，选中数据
    handleRowClick (row) {
      this.studentInfoReview(row)
      this.$refs.multipleTable.toggleRowSelection(row);
      this.selectChange(this.multipleSelection)
    },


    // 改变选中的数据
    selectChange(selection, row) {
      if (this.showDetail == true  && selection.length > 1) {
        const del_row = selection.shift()
        this.$refs.multipleTable.toggleRowSelection(del_row, false)
      }
    },

    getRowKeys(row) {
      //缓存列表状态
      return row.id; 
    },
 
    // 批量通过 (表格上面的按钮)
    onPass(id){
      if(Array.isArray(id) || !id.length){
        if(!id.length) {
          this.$message({
            message: "请最少选择一项",
            type: "error",
          })
          return
        }else if(id.some(item => item.statusText !== '待审核')){
          this.$message({
            message: "请选择状态为待审核的考生",
            type: "error",
          })
          return
        }
      }
 
      this.passDialogVisible = true
      this.passId = id.map(item => item.id).join(',')
      this.getPageList()
    },
 
    // 批量驳回 (表格上面的按钮)
    onReject(id){
      if(Array.isArray(id) || !id.length){
        if(!id.length) {
          this.$message({
            message: "请最少选择一项",
            type: "error",
          })
          return
        }else if(id.some(item => item.examPay == 'examineePay' && item.statusText !== '待审核' || item.examPay == 'institutionPay' && item.payType == null && item.statusText !== '待审核')){
          this.$message({
            message: "请选择支付状态为待确认或报名审核状态为待审核的考生",
            type: "error",
          })
          return
        }
      }
 
      this.rejectDialogVisible = true;
      this.rejectId = id.map(item => item.id).join(',')
      this.getPageList()
    },
 
    // 确认已收款
    onConfirmReceipt(id){
      if(Array.isArray(id) || !id.length){
        if(!id.length){
          this.$message({
            message: "请最少选择一项",
            type: "error",
          })
          return
        }else if(id.some(item => item.payStatusText !== '待确认')){
          this.$message({
            message: "请选择支付状态为待确认的考生",
            type: "error",
          })
          return
        }
      }
      this.confirmDialogVisible = true
      this.receiptId = id.map(item => item.id).join(',')
      this.getPageList()
    },
    
    // 导出所有考生报名信息
    onExportAll: function(){
      if(!this.appraisalId){
        this.$message({
            message: "请选中一个批次再导出",
            type: "error",
        })
      }else{
        let params = {
          appraisalId: this.appraisalId
        }
        this.$http.post('/examFile/export/total', params, {responseType: 'blob'}).then(res => {
          if(res.data){
            // 获取响应头中的 filename, 并解码, 实现动态获取文件名
            let filename=decodeURIComponent(res.headers.filename)
            downloadBlob(res.data, filename)
          }else{
            this.$message({
              message: res.data.msg,
              type: "error",
            })
          }
        }).catch(()=>{
          this.$message({
            type: 'error',
            message: '导出失败'
          })
        })
      }
    },
 
    // 导出评价方审核名单信息
    onExport(){
      if(!this.appraisalId){
        this.$message({
          message: "请选中一个批次再导出",
          type: "error",
        })
        return
      }else{
        let params = {
          appraisalId: this.appraisalId
        }
        this.$http.post('/association/export/getExport', params, {responseType: 'blob'}).then(res => {
          if(res.data){
            // 获取响应头中的 filename, 并解码, 实现动态获取文件名
            let filename = decodeURIComponent(res.headers.filename)
            downloadBlob(res.data, filename)
          }else{
            this.$message({
              message: res.data.msg,
              type: "error",
            })
          }
        })
      }
    },

    
    // 修改选中行的背景颜色和字体颜色
    tableRowClassName({row}) {
      let flag = this.multipleSelection.some(item => item.id == row.id)
      if(flag){
        return "selected-row";
      }else{
        return "";
      }
    },

    // 查看支付凭证
    payPreview(url) {
      this.currentPreviewUrl = url;
      this.payPreviewFlag = true;
    },
 
    // 查看考生信息
    studentInfoReview(row) {
      this.showDetail = true
      this.multipleSelection.forEach(item => {
        if(item && item.id == row.id){
          // 只有当 item.id 与 row.id 相同时, 才能隐藏右侧的详情页, 避免用户点击上一条数据再点击下一条数据时，直接隐藏详情页
          this.showDetail = false
        }else{
          this.showDetail = true
        }
      })
      this.showOrHideInfo()
      this.detailInfo = row
      this.detailInfo.detailStatus = this.confirmStatus
      this.infoId = row.id
      this.$nextTick(() => this.$refs.infoContainer.fetchDetails())
    },

    // 控制右侧详情页的显示与隐藏
    showOrHideInfo(){
      let infoBox = document.querySelector('.info_container')
      if(this.showDetail == true){
        this.$refs.tabsContaniner.style.width = '80%'
        infoBox.style.width = '20%'
        this.$refs.tabsContaniner.style['marginRight'] = '20px'
      }else{
        this.$refs.tabsContaniner.style.width = '100%'
        infoBox.style.width = '0'
      }
    },
 
    // 点击  "通过" 图标
    gotoPass(row){
      this.passDialogVisible = true;
      this.passRow = row
      this.passId = row.id
    },
 
    // 点击 "确认已收款" 图标
    gotoConfirm(row){
      this.confirmDialogVisible = true
      this.receiptRow = row
      this.receiptId = this.receiptRow.id
    },
    
    // 点击 "驳回" 图标
    gotoReject(row){
      this.rejectDialogVisible = true;
      this.rejectRow = row
      this.rejectId = row.id
    },
    
    // 点击 "通过"图标后，点击 弹框的 "确定"按钮
    onPassConfirm() {
      this.$http.put(`association/pass?ids=` + this.passId).then((res) => {
        if(res.data.success && res.status == 200){
          this.$message({
            message: "通过成功",
            type: "success",
          })
          if(this.passRow.examPay === 'examineePay'){
            this.passRow.status = 'toTest'
          }else if (this.passRow.examPay === 'institutionPay'){
            this.passRow.status = 'payAuditing'
          }
          this.$refs.multipleTable.toggleRowSelection(this.passRow,false) // 取消选中状态
          this.getPageList() // 改变状态以后调用一下这个方法，刷新页面
        }
      });
      this.passDialogVisible = false
    },
 
    // 点击 "通过"图标后，点击 弹框的 "取消"按钮
    onPassCancel() {
      this.passDialogVisible = false
    },
 
    // 点击"确认已收款"图标后，点击 弹框的 "确定"按钮
    onReceiptConfirm() {
      this.$http.put(`association/confirmReceipt?ids=` + this.receiptId).then((res) => {
        if (res.data.success && res.status == 200) {
          this.$message({
            message: "确认收款成功",
            type: "success",
          })
          this.receiptRow.payStatus = 'paid'
          this.receiptRow.status = 'toTest'
          this.$refs.multipleTable.toggleRowSelection(this.receiptRow,false) // 取消选中状态
          this.getPageList() // 取消状态以后再次调用这个方法，刷新页面
        }
      })
      this.confirmDialogVisible = false
    },
 
    // 点击 "确认已收款"图标后，点击 弹框的 "取消"按钮
    onReceiptCancel() {
      this.confirmDialogVisible = false
    },
 
    // 点击 "驳回"图标后，点击 弹框的 "确定"按钮
    onRejectConfirm(){
      if(!this.rejectReason){
        this.$message({
          message: "请输入驳回原因",
          type: "error",
        })
        this.rejectDialogVisible = true;
      }else{
        this.$http.put(`association/reject?ids=` + this.rejectId + `&reason=` + this.rejectReason).then((res) => {
          if (res.data.success && res.status == 200) { 
            this.$message({
              message: "驳回成功",
              type: "success",
            })
            if(this.rejectRow.payStatus !== null) {
              this.rejectRow.payStatus = 'rejected' // 支付驳回
              this.rejectRow.status = 'payRejected' // 报名审核状态是 "通过"
            }else{
              this.rejectRow.status = 'rejected'
            }
            this.$refs.multipleTable.toggleRowSelection(this.rejectRow,false) // 取消选中状态
            this.getPageList() // 取消状态以后再次调用这个方法，刷新页面
          }
        });
        this.rejectDialogVisible = false;
      }
    },
 
    // 点击 "驳回"图标后点击 弹框的 "取消"按钮
    onRejectCancel(){
      this.rejectDialogVisible = false;
    },
 
    // 关闭弹框
    close(done){
      this.auditStatus = this.auditStatus // 点击 "关闭" 对话, 控制状态不变
      done()
    },
    
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>
 
<style lang="less" scoped>
 
.audit_container {
  min-width: 1800PX;
  box-sizing: border-box;
}

.audit_container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  display: -webkit-flex;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: @whitee;
  width: 100%;
  -webkit-width: 100%; /*谷歌浏览器*/
  -ms-width: 100%;     /*IE浏览器*/
  -moz-width: 100%;    /*火狐浏览器*/
  -o-width: 100%;      /*欧朋浏览器*/
  padding: 30px;
  // height: 100vh;
}
 
.tab_container{ 
  // margin-top: -20px;
  width: 100%;
  height: 100%;
  overflow: auto; 
}

.info_container{
  overflow: auto; 
  height: 100%;
}
 
.audit_button_box {
  display: flex;
  justify-content: flex-end;
  margin: 40px 0;
}
// .audit_button_box button {
//   width: 200px;
//   height: 80px;
//   margin: 0 20px 0 0;
// }
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.operation_img {
  width: 25PX !important;
  height: 25PX !important;
  display: block;
  margin: 0 3PX
}
.audit_select_flex {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-left: 40PX;
}
.audit_select_box{
  display: flex;
  justify-content: flex-start;
  margin-top: 50px;
}
.audit_select_item{
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-right: 100px;
  .search-title{
    font-size: 14PX;
  }
}
 
.table_wrapper {
  flex: 1;
  width: 100%;
  margin-top: 10px;
  height: 650PX;
  position: relative;
  .table_content {
    position: absolute;
    width: 100%;
    margin: 0;
    ::v-deep .el-table__header, ::v-deep .el-table__body{
      // 解决 el-table在谷歌和360极速浏览器的兼容问题
      width:100% !important;
    }
 
    .table_content_operation{
      display: flex;
      justify-content: center;
    }
  }
}
 
 
// ElementUI 对话框的 样式
::v-deep .el-dialog__wrapper {
  position: fixed;
  top: 25%;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
::v-deep .el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 25px 25px 30px;
}
::v-deep .el-dialog__body {
  color: #606266;
  font-size: 14PX;
  word-break: break-all;
  textarea{
    background-color: rgb(246, 246, 246);
    border: none;
    width: 520px;
    height: 300px;
  }
}

::v-deep .el-table .selected-row {
  background: #e4f3fd;
  color: #409eff;
}
</style>



